import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import config from "../../utils/awsConfig";
import { uploadFile } from "../../lib/ReactS3";
import { Editor } from '@tinymce/tinymce-react';

import { DropzoneArea } from '../DropzoneArea';

import { addArticle, updateArticle, getArticleProducts, addArticleProductAssociation, deleteArticleProductAssociation, getAllUrlTitles } from "../../redux/actions/articles";
import { searchProducts } from "../../redux/actions/products";
import { getAllUsers } from "../../redux/actions/users";
import { setAlert } from "../../redux/actions/alerts";
import { selectArticleForTemplate, setReturnUrl } from "../../redux/actions/articleTemplates";
import { getArticleTypes } from "../../redux/actions/articleTypes";

import { urlTitleFormatting } from "../../helpers/urlTitleFormatting";
import inputLimit from '../../utils/inputLimitConfig';

import SearchDropdown from "../Shared/SearchDropdown";
import SelectDropdown from "../Shared/SelectDropdown";
import DisplayRemainingCharacters from "../Shared/DisplayRemainingCharacters";

import styles from '../../styles/Components/Shared/ArticleForm.module.css';
import KeyTakeaway from "./KeyTakeaway";
import Contributors from "./Contributors";

const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';

const editorApiKey = process.env.REACT_APP_TINY_KEY


const custom_image_upload_handler = (file, success) => {
    uploadFile(file.blob(), config)
        .then((data) => {
            success('https://dh1bsjhakq06i.cloudfront.net/' + data.filename)
        })
        .catch((err) => console.error(err));
}

const classes = {
    dropZone: {
        imageSection: {
            width: '100%',
            maxWidth: '100%'
        },
        imagePreview: {
            width: '100%',
            height: '125px'
        },
        image: {
            height: '125px'
        },
      height: "200px",
      minHeight: '200px'
    },
};

const ArticleForm = ({
    page,
    searchTerm,
    newestFilter,
    manufacturerFilter,
    type,
    pageArticleType,
    addArticle,
    updateArticle,
    getArticleProducts,
    handleClose,
    searchProducts,
    getAllUsers,
    addArticleProductAssociation,
    deleteArticleProductAssociation,
    setAlert,
    selectArticleForTemplate,
    setReturnUrl,
    getArticleTypes,
    getAllUrlTitles,
    article: { selectedArticle, articleProducts, allUrlTitles },
    articleType: { articleTypes },
    auth: { accountUser, users },
    product: { productSearch },
}) => {
    const [formPage, setFormPage] = useState(0);
    const editorRef = useRef(null);
    const overviewRef = useRef(null);
    const prodName = useRef();
    // const classes = useStyles();
    const defaultArticle = {
        article_type: "",
        article_type_id: null,
        content: "",
        overview: "",
        create_date: "",
        modified_date: new Date(),
        publish: false,
        published_at: "",
        short_description: "",
        thumbnail: null,
        thumbnail_path: null,
        title: "",
        author: "",
        date: "",
        urlTitle: "",
        call_to_action: "",
        pdf_link: "",
        embed_form_title: "",
        hubspot_form_id: "",
        is_templated: false,
        exclude_newsfeed: false,
        alt_tag: null,
    }
    const [post, setPost] = useState({
        ...defaultArticle
    });
    
    const [productList, setProductList] = useState([]);
    const [productAssociationToDelete, setProductAssociationToDelete] = useState([])
    const [impersonate, setImpersonate] = useState(false);
    const [productOptions, setProductOptions] = useState([]);
    const [authorOptions, setAuthorOptions] = useState([]);
    const [articleTypeOptions, setArticleTypeOptions] = useState([]);
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [existingURL, setExistingURL] = useState('');
    const [clearImage, setClearImage] = useState(0);
    const [clearPDF, setClearPDF] = useState(0);

    const defaultTakeaway = Array.from({ length: 3,}, (_, i) => ({ summary: '', order: i + 1 }))
    const [takeaways, setTakeaways] = useState(defaultTakeaway)

    const defaultContributor = { name: '', credentials: '', location: '' }

    const [contributors, setContributors] = useState([{...defaultContributor }])

    const {
        title,
        author,
        date,
        content,
        overview,
        article_type,
        publish,
        urlTitle,
        ebookExternalLink,
        call_to_action,
        pdf_link,
        embed_form_title,
        hubspot_form_id,
        short_description,
        thumbnail,
        thumbnail_path,
        is_templated,
        exclude_newsfeed,
        alt_tag,
    } = post;

    useEffect(() => {
        let options = [];

        if (users?.length > 0) {
            options = users.map(user => ({
                name: `${user.firstName} ${user.lastName}`,
                value: user.userId
            }))
        }

        setAuthorOptions([...options])
    }, [users])

    useEffect(() => {
        let options = [];

        if (productSearch?.length > 0) {
            options = productSearch.map(product => ({
                name: product.name,
                value: product
            }))
        }

        setProductOptions([...options])
    }, [productSearch])

    useEffect(() => {
        let options = [];

        if (articleTypes?.length > 0) {
            options = articleTypes.map(articleType => ({
                name: articleType.name === 'CE' ? 'Continuing Ed. (Dental Learning)' : articleType.name === 'Viva' ? 'Continuing Ed. (Viva Learning)' : articleType.name === 'other' ? 'Other' : articleType.name,
                value: articleType.name
            }))
        }

        setArticleTypeOptions([...options])
    }, [articleTypes])

    const navigate = useNavigate();

    
    useEffect(() => {
        getAllUrlTitles()
        getArticleTypes()
    }, [getAllUrlTitles, getArticleTypes])

    useEffect(() => {
        if (selectedArticle) {
            setPost({
                article_id: selectedArticle.article_id,
                article_type: selectedArticle.article_type,
                article_type_id: selectedArticle.article_type_id,
                content: selectedArticle.content,
                overview: selectedArticle.overview,
                publish: selectedArticle.publish,
                create_date: selectedArticle.create_date,
                short_description: selectedArticle.short_description,
                thumbnail: selectedArticle.thumbnail,
                thumbnail_path: selectedArticle.thumbnail_path,
                title: selectedArticle.title,
                author: selectedArticle.author,
                date: selectedArticle.published_at,
                urlTitle: selectedArticle.urlTitle,
                ebookExternalLink: selectedArticle.ebookExternalLink,
                call_to_action: selectedArticle.call_to_action,
                pdf_link: selectedArticle.pdf_link,
                embed_form_title: selectedArticle.embed_form_title,
                hubspot_form_id: selectedArticle.hubspot_form_id,
                is_templated: selectedArticle.is_templated,
                exclude_newsfeed: selectedArticle.exclude_newsfeed ? true : false,
                alt_tag: selectedArticle.alt_tag,
            });
            
            setExistingURL(selectedArticle.urlTitle)
            getArticleProducts(selectedArticle.article_id)
            
            if (selectedArticle.KeyTakeaways?.length > 0) {
                let takeawayData = []
                
                selectedArticle.KeyTakeaways.sort((a, b) => a.order - b.order)
                
                for (let i = 0; i < 3; i++) {
                    if (selectedArticle.KeyTakeaways[i]) {
                        takeawayData.push(selectedArticle.KeyTakeaways[i])
                    } else {
                        takeawayData.push({ summary: '', order: i + 1 })
                    }
                }
                setTakeaways(takeawayData)
            } 

            if (selectedArticle.Contributors?.length > 0) {
                
                setContributors(selectedArticle.Contributors.sort((a, b) => a.contributor_id - b.contributor_id))
            } 
        } 
    }, [selectedArticle, getArticleProducts, type, accountUser]);

    useEffect(() => {
        if (articleTypes?.length > 0 && !selectedArticle && type) {
            const foundType = articleTypes.find(e => e.name === type)

            if (foundType) {
                setPost(prevPost => ({
                    ...prevPost,
                    article_type: foundType.name,
                    article_type_id: foundType.article_type_id
                }))
            }
        }
    }, [selectedArticle, type, articleTypes])

    useEffect(() => {
        if (!selectedArticle && accountUser) {
            setPost(prevPost => ({
                ...prevPost,
                author: accountUser.userId
            }))
        }
    }, [selectedArticle, accountUser])

    useEffect(() => {
        if (articleProducts.length > 0) {
            articleProducts.forEach(product => {
                product.isNew = false;
                product.productName = product?.Product?.name ? product.Product.name : ''
            })
            setProductList([...articleProducts])
        }
    }, [articleProducts])

    useEffect(() => {
        if (accountUser.permissions.length > 0) {
            accountUser.permissions.forEach(permission => {
                if (permission.permission === 'impersonate') {
                    setImpersonate(true)
                }
            })
        }
        getAllUsers()
    }, [accountUser, getAllUsers])

    useEffect(() => {
        getArticleTypes()
    }, [getArticleTypes])
    
    const checkNotEmptyOrComplete = (contributor) => {
        return !((contributor.name?.trim() !== '' && contributor.credentials?.trim() !== '' && contributor.location?.trim() !== '') ||
        (contributor.name?.trim() === '' && contributor.credentials?.trim() === '' && contributor.location?.trim() === ''))
    }
    const validateFields = () => {
        const missingFields = [
            ...!title ? ['Title'] : [],
            ...!urlTitle ? ['Url Title'] : [],
            ...!short_description ? ['Article List Page Description'] : [],
            ...!content && !is_templated ? ['Article Body'] : [],
            ...urlTitle && allUrlTitles.some(el => (!selectedArticle || selectedArticle.article_id !== el.article_id) && el.urlTitle === urlTitle) ? ['Duplicate Url Title in article database - make it unique'] : [],
            ...!(productList?.length > 0) ? ['at least one product'] : [],
        ]

        if (formPage === 1 && contributors.length > 0) {
            const foundIncomplete = contributors.find(checkNotEmptyOrComplete)

            if (foundIncomplete) {
                missingFields.push('Complete or Remove Contributors')
            }
        }

        if (missingFields?.length > 0) {
            setAlert(`Please fill out required fields: ${new Intl.ListFormat('en-us').format(missingFields)}`, 'danger')
        }

        return missingFields.length === 0
    }

      
    const checkExceededCharacters = (urlTitle) => {
        const fieldsExceedingSize = [
            ...title && title.length > inputLimit.dps_articles.title ? ['Title'] : [],
            ...embed_form_title && embed_form_title.length > inputLimit.dps_articles.embed_form_title ? ['Embed Form Title'] : [],
            ...hubspot_form_id && hubspot_form_id.length > inputLimit.dps_articles.hubspot_form_id ? ['Hubspot Form ID'] : [],
            ...call_to_action && call_to_action.length > inputLimit.dps_articles.call_to_action ? ['Call to Action'] : [],
            ...pdf_link && pdf_link.length > inputLimit.dps_articles.pdf_link ? ['PDF Filename'] : [],
            ...thumbnail && thumbnail.length > inputLimit.dps_articles.thumbnail || 
                thumbnail_path && thumbnail_path.length > inputLimit.dps_articles.thumbnail_path ? ['Image Filename'] : [],
            ...urlTitle.length > inputLimit.dps_articles.urlTitle ? ['URL Title'] : [],
            ...alt_tag && alt_tag.length > inputLimit.dps_articles.alt_tag ? ['Alt Tag'] : [],
        ]
        
        if (fieldsExceedingSize.length > 0) {
            setAlert(`The following inputs exceed the character limit: ${fieldsExceedingSize.join(', ')}.`, 'danger')
            return true
        }

        return false
    }

    const handleSubmit = async (e, cb) => {
        e.preventDefault();

        if (validateFields()) {
            
            const validURL = urlTitle !== existingURL ? await urlTitleFormatting(urlTitle, 'articles', process.env.REACT_APP_BASE_URL) : urlTitle

            if (checkExceededCharacters(validURL)) {
                return
            }

            const takeawayData = takeaways.filter(e => e.summary?.trim())
            const contributorData = contributors.filter(e => e.name?.trim() && e.credentials?.trim() && e.location?.trim())

            if (selectedArticle) {
                await updateArticle(post.article_id, {...post, urlTitle: validURL,}, takeawayData, contributorData, pageArticleType, page, searchTerm, newestFilter, manufacturerFilter);
                const newProducts = productList?.filter(product => product.isNew)
                if (newProducts.length > 0) {
                    addArticleProductAssociation(newProducts)
                }
                if (productAssociationToDelete.length > 0) {
                    productAssociationToDelete.forEach(association => {
                        // if (association.deleted === true) {
                            deleteArticleProductAssociation(association.article_id, association.product_id)
                        // }
                    })
                }
            } else {
                await addArticle({...post, urlTitle: validURL,}, productList, takeawayData, contributorData, pageArticleType, page, searchTerm, newestFilter, manufacturerFilter);
                if (is_templated) {
                    navigate(`/onsite-content/template`)
                }
            }

            setPost({
                ...defaultArticle
            });

            if (cb) {
                cb()
            }

            setProductList([])
            setTakeaways(defaultTakeaway)
            handleClose();
        } 
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        let additionalChanges = {}
        if (name === 'title' && !selectedArticle) {
            additionalChanges = {
                urlTitle: value.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '-')
            }
        }

        setPost({
            ...post,
            [name]: value,
            ...additionalChanges
        });
    };

    
    const handleSelectChange = (value, name) => {
        let additionalChanges = {}
        if (name === 'article_type') {
            const foundArticleType = articleTypes?.find(e => e.name === value)

            if (foundArticleType) {
                additionalChanges = {
                    article_type_id: foundArticleType.article_type_id
                }
            }
        }
        setPost(prevPost => ({
            ...prevPost,
            [name]: value,
            ...additionalChanges
        }));
    };

    const handleEditorChange = (data, editorName) => {
        setPost(prevPost => ({
            ...prevPost,
            
            ...editorName === 'content' ? { content: editorRef.current.getContent() } : {},

            ...editorName === 'overview' ? { overview: overviewRef.current.getContent() } : {},
        }))
    };

    const checkFileExceedsCharacterLimit = (fileName, property) => {
        if (property === 'thumbnail' && fileName?.length > inputLimit.dps_articles.thumbnail_path) {
            setClearImage(prevImage => prevImage + 1)
            setAlert(`The Image Filename exceeds the character limit.`, 'danger')
            return true;
        } else if (property === 'pdf_link' && fileName?.length > inputLimit.dps_articles.pdf_link) {
            setClearPDF(prevImage => prevImage + 1)
            setAlert(`The PDF Filename exceeds the character limit.`, 'danger')
            return true;
        }

        return false;

    }

    //handles the drop event, sets the returned value from s3 bucket to the dropName value in state
    const handleDrop = (acceptedFiles, property) => {
        acceptedFiles.forEach((file) => {
            const newName = `${Date.now()}-${file.name}`

            if (checkFileExceedsCharacterLimit(newName, property)) {
                return setAlert(`The Image Filename exceeds the character limit.`, 'danger')
            }

            uploadFile(file, config)
                .then((data) => {

                    if (checkFileExceedsCharacterLimit(data.location, property)) {
                        return
                    }

                    if (property === 'thumbnail') {
                        setPost({
                            ...post,
                            [property]: data.location,
                            thumbnail_path: data.filename
                        });

                    } else {
                        setPost({
                            ...post,
                            [property]: data.location,
                        });

                    }
                })
                .catch((err) => console.error(err));
        });
    };

    const handleDelete = (property) => {
        if (property === 'thumbnail') {
            setPost({
                ...post,
                [property]: null,
                thumbnail_path: null,
                alt_tag: null,
            });

        } else {
            setPost({
                ...post,
                [property]: '',
            });

        }
    };

    const searchForProducts = (value) => {
        if (!value) {
            return
        }

        if (value.length < 2) {
            setAlert("Query must be 2 characters or longer", "danger");
        } else {
            searchProducts(value);
        }
    };
    
    useEffect(() => {
        const timeout = setTimeout(() => {
            searchForProducts(productSearchTerm)
        }, 1000);

        return  () => clearTimeout(timeout)
    }, [productSearchTerm])

    const handleProductSelect = (product) => {
        let updatedProductList = [...productList];
        if (product) {
            let isNew = true;

            // IF DELETED AND SELECTED AGAIN
            if (productAssociationToDelete?.length > 0) {
                const foundIndex = productAssociationToDelete.findIndex(prod => prod.product_id === product.product_id)

                if (foundIndex !== -1) {
                    const existingToDelete = productAssociationToDelete
                    existingToDelete.splice(foundIndex, 1)
                    setProductAssociationToDelete([...existingToDelete])
                    isNew = false;
                }
            }

            updatedProductList.push({ product_id: product.product_id, productName: product.name, article_id: post.article_id, isNew })
            setProductList(updatedProductList)

        }
    };

    const removeProducts = (index) => {
        const currentProducts = productList
        const productToDelete = currentProducts.splice(index, 1)

        setProductList([...currentProducts])

        if (productToDelete && productToDelete[0] && productToDelete[0].article_id && productToDelete[0].product_id && !productToDelete[0].isNew) {
            setProductAssociationToDelete(prevList => [
                ...prevList, 
                productToDelete[0]
            ])
        }
    }

    // const handleDeleteCheckboxes = (e) => {
    //     let updatedArticleProds = [...currentArticleProducts]
    //     updatedArticleProds.forEach(product => {
    //         if (product.product_id === parseInt(e.target.name)) {
    //             if (e.target.value === 'false') {
    //                 product.deleted = true
    //             } else {
    //                 product.deleted = false
    //             }
    //         }
    //     })
    //     setCurrentArticleProducts([...updatedArticleProds])
    // };

    const viewTemplate = (e) => {
        setPost(prevPost => ({
            ...prevPost,
            is_templated: true
        }))
        selectArticleForTemplate(selectedArticle)
        setReturnUrl(`/onsite-content/${type ? type?.replaceAll(' ', '-') : article_type?.replaceAll(' ', '-')}`)
        handleSubmit(e, () => navigate(`/onsite-content/template`))

    }
    
    const changeFormPage = (direction) => {
        if (direction === 'next' && validateFields()) {
            setFormPage(formPage + 1)
        } else if (direction === 'back') {
            setFormPage(formPage - 1)
        }
    };
    return (
        <div className={styles.article_form_container}>
            <p className={styles.article_form_header}>{`${selectedArticle ? 'Edit' : 'Add New'} ${article_type === 'other' ? 'Other' : article_type} Article`}</p>
      
            <div className={styles.article_form_input_container}>
            {
                formPage === 0 ?
                    <>
                        <div className={styles.article_form_header_container}>
                            <p className={styles.article_sub_form_header}>{article_type === 'other' ? 'Other' : article_type} Article Details</p>
                            <div className={'input_container '}  >
                                <label>Article Type</label>
                                <SelectDropdown
                                    options={articleTypeOptions} 
                                    placeholder={'Article Type'} 
                                    handleSelect={(option) => handleSelectChange(option, 'article_type')}
                                    selection={article_type ? article_type : ''}
                                />
                            </div>
                        </div>
                        <div className={`input_container ${styles.article_grid_span_2}`}>
                            <label>{article_type === 'other' ? 'Other' : article_type} Title</label>
                            <input 
                                className={`input_basic`}
                                type='text'
                                name='title'
                                placeholder={`${article_type === 'other' ? 'Other' : article_type} Title`}
                                value={title ? title : ''}
                                onChange={(e) => handleChange(e)}
                                maxLength={inputLimit.dps_articles.title}
                            />
                            <DisplayRemainingCharacters
                                characterLimit={inputLimit.dps_articles.title}
                                current={title}
                            />
                        </div>
                        <div className={styles.article_form_input_grid}>
                            <div className={`${styles.article_grid_span_2}`}>
                            
                                {selectedArticle ? 
                                    <div className={`input_container ${styles.article_url_title}`}>
                                        <label>URL Title</label>
                                        <input 
                                            className={`input_basic`}
                                            type='text'
                                            name='urlTitle'
                                            placeholder={'URL Title'}
                                            value={urlTitle ? urlTitle : ''}
                                            onChange={(e) => handleChange(e)}
                                            maxLength={inputLimit.dps_articles.urlTitle}
                                        />
                                        
                                        <DisplayRemainingCharacters
                                            characterLimit={inputLimit.dps_articles.urlTitle}
                                            current={urlTitle}
                                        />
                                    </div>
                                : null}
                                <div className={`input_container`}>
                                    <label>Author</label>
                                    <SearchDropdown
                                        options={authorOptions ? authorOptions : []} 
                                        placeholder={'Author'} 
                                        handleSelect={(option) => handleSelectChange(option, 'author')}
                                        selection={author ? author : null}
                                        disabled={!impersonate}
                                    />

                                </div>
                                

                            </div>
                            <div className={`${styles.article_grid_span_2}`}>
                                <div className={`input_container`}>
                                    <label>Select Product</label>
                                    <SearchDropdown
                                        options={productOptions ? productOptions : []} 
                                        placeholder={'Please start typing or use dropdown to search'} 
                                        handleSelect={(option) => handleProductSelect(option)}
                                        clearOnSelect={true}
                                        handleSearch={(value) => setProductSearchTerm(value)}
                                        emptyOption={"No Options"}
                                        // selection={selectedCategory ? selectedCategory.category_id : null}
                                    />

                                </div>
                                {productList?.length > 0 ? 
                                    <div>
                                        <div className={`${styles.article_form_list_container}`}>
                                            {productList.map((product, i) => (
                                                <div className={styles.article_form_list} key={`product-${i}`}>
                                                    <p>{product.productName}</p>
                                                    <button className={'button_text'} onClick={() => removeProducts(i)}>
                                                        <img src={TrashIcon} alt="Trash Icon" />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                : null}
                            </div>


                            <div className={`${styles.article_sub_grid} ${styles.article_grid_span_2}`}>
                                {/* <div className={`input_container ${styles.article_grid_span_2}`}>
                                    <label>Manufacturer</label>
                                    <SearchDropdown
                                        options={manufacturerOptions ? manufacturerOptions : []} 
                                        placeholder={selectedManufacturer ? selectedManufacturer.name : 'Please start typing or use dropdown to search'} 
                                        handleSelect={(option) => handleManufacturerSelect(option)}
                                        handleSearch={searchForManufacturer}
                                        emptyOption={"No Options"}
                                        clear={() => handleManufacturerSelect(null)}
                                        selection={selectedManufacturer ? selectedManufacturer.manufacturer_id : null}
                                    />

                                </div> */}
                                <div className={'input_container '}  >
                                    <label>Hide From Newsfeed?</label>
                                    <SelectDropdown 
                                        options={[
                                            {name: 'Yes', value: true},
                                            {name: 'No', value: false},
                                        ]} 
                                        placeholder={'Hide From Newsfeed?'} 
                                        handleSelect={(option) => handleSelectChange(option, 'exclude_newsfeed')}
                                        selection={exclude_newsfeed !== null ? exclude_newsfeed : ''}
                                    />
                                   

                                </div>
                                <div className={'input_container '}  >
                                    <label>Publish Article?</label>
                                    <SelectDropdown
                                        options={[
                                            {name: 'Yes', value: true},
                                            {name: 'No', value: false},
                                        ]} 
                                        placeholder={'Publish Article?'} 
                                        handleSelect={(option) => handleSelectChange(option, 'publish')}
                                        selection={publish !== null ? publish : ''}
                                    />
                                   

                                </div>
                                
                            </div>
                        </div>
                        <div className={`input_container ` + styles.article_text_area_container}>
                            <label>Article Description</label>
                            <textarea 
                                className={`input_basic ` + styles.article_text_area}
                                type='text'
                                name='short_description'
                                placeholder="Article Description"
                                value={short_description ? short_description : ''}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>
                        <div className={`input_container ${styles.article_form_template_select}`}  >
                            <label>Use Template Sys. Or WYSIWYG?</label>
                            <SelectDropdown 
                                options={[
                                    {name: 'Template', value: true},
                                    {name: 'Custom', value: false},
                                ]}
                                placeholder={'Use Template Sys. Or WYSIWYG?'} 
                                handleSelect={(option) => handleSelectChange(option, 'is_templated')}
                                selection={is_templated ? is_templated : ''}
                                dropDownAbove={is_templated}
                            />

                        </div>
                        {!is_templated ?
                            <div className={`input_container ${styles.article_editor_container}`}>
                                <label>Article WYSIWYG Description</label>
                                <Editor
                                    value={content ? content : ''}
                                    onInit={(evt, editor) => editorRef.current = editor}
                                    apiKey={editorApiKey}
                                    onEditorChange={(newText) => handleEditorChange(newText, 'content')}
                                    init={{
                                        height: 250,
                                        plugins: [
                                            'advlist autolink lists link image charmap print preview anchor',
                                            'searchreplace visualblocks code fullscreen',
                                            'insertdatetime media table paste imagetools code help wordcount'
                                        ],
                                        paste_as_text: true,
                                        menubar: 'file edit view insert format tools table tc help',
                                        toolbar: 'undo redo | formatselect | ' +
                                            'bold italic backcolor | alignleft aligncenter ' +
                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                            'removeformat | link image | code | help',
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                        images_upload_handler: custom_image_upload_handler,
                                    }}
                                />
                            </div>
                        : null}
                        
                        <div className={`input_container `} >
                            <label>Article Overview</label>
                            <Editor
                                value={overview ? overview : ''}
                                onInit={(evt, editor) => overviewRef.current = editor}
                                apiKey={editorApiKey}
                                onEditorChange={(newText) => handleEditorChange(newText, 'overview')}
                                init={{
                                    height: 250,
                                    plugins: [
                                        'advlist autolink lists link image charmap print preview anchor',
                                        'searchreplace visualblocks code fullscreen',
                                        'insertdatetime media table paste imagetools code help wordcount'
                                    ],
                                    paste_as_text: true,
                                    menubar: 'file edit view insert format tools table tc help',
                                    toolbar: 'undo redo | formatselect | ' +
                                        'bold italic backcolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | link image | code | help',
                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                    images_upload_handler: custom_image_upload_handler,
                                }}
                            />
                        </div>

                        {/* <KeyTakeaway takeaways={takeaways} setTakeaways={setTakeaways}/> */}
                       
                    </>
                
            : null}
            
            {formPage === 1 ?
                <div>
                        <KeyTakeaway takeaways={takeaways} setTakeaways={setTakeaways}/>
                        <Contributors contributors={contributors} setContributors={setContributors}/>

                </div>
            : null}

            {formPage === 2 ?
                <div>
                    <div className={styles.article_upload_form_wrapper}>
                        <p className={styles.article_upload_header}>{article_type === 'other' ? 'Other' : article_type} Image</p>
                        <p className={styles.article_upload_sub_header}>{`Once you add an image below you may replace it by adding a new one to take it's place`}</p>
                        <div className={styles.article_upload_container}>
                            <DropzoneArea
                                acceptedFiles={['image/*']}
                                dropzoneClass={classes.dropZone}
                                dropzoneText={thumbnail_path ? thumbnail_path : 'Add Image'}
                                showPreviewsInDropzone={false}
                                showPreviews={true}
                                showFileNamesInPreview={true}
                                initialFiles={thumbnail_path ? [thumbnail_path] : null}
                                filesLimit={1}
                                onChange={(e) => handleDrop(e, 'thumbnail')}
                                onDelete={() => handleDelete('thumbnail')}
                                refresh={clearImage}
                            />
                        </div>
                        {thumbnail_path ? 
                            <div className={`input_container ${styles.article_upload_alt_tag}`}>
                                {alt_tag ?
                                    <label>{article_type === 'other' ? 'Other' : article_type} Alt Tag</label>
                                : null}
                                <input
                                    className={`input_basic`}
                                    type='text'
                                    name={`alt_tag`}
                                    placeholder="Enter Alt Tag"
                                    value={alt_tag ? alt_tag : ''}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={inputLimit.dps_articles.alt_tag}
                                />
                                
                                <DisplayRemainingCharacters
                                    characterLimit={inputLimit.dps_articles.title}
                                    current={alt_tag}
                                />
                            </div>
                        : null}

                    </div>

                    <hr className={styles.article_form_divider}/>
                    <div className={styles.article_upload_form_wrapper}>
                        <p className={styles.article_upload_header}>{`${article_type === 'other' ? 'Other' : article_type} eBook Details (if relevant)`}</p>
                        <div className={styles.article_ebook_inputs}>
                            <div className={`input_container`}>
                                {embed_form_title ?
                                    <label>Embed Form Title</label>
                                : null}
                                <input
                                    className={`input_basic`}
                                    type='text'
                                    name={`embed_form_title`}
                                    placeholder="Embed Form Title"
                                    value={embed_form_title ? embed_form_title : ''}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={inputLimit.dps_articles.embed_form_title}
                                />
                                
                                <DisplayRemainingCharacters
                                    characterLimit={inputLimit.dps_articles.embed_form_title}
                                    current={embed_form_title}
                                />
                            </div>
                            <div className={`input_container`}>
                                {hubspot_form_id ?
                                    <label>{`eBook Hubspot Form ID`}</label>
                                : null}
                                <input
                                    className={`input_basic`}
                                    type='text'
                                    name={`hubspot_form_id`}
                                    placeholder={`eBook Hubspot Form ID`}
                                    value={hubspot_form_id ? hubspot_form_id : ''}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={inputLimit.dps_articles.hubspot_form_id}
                                />
                                
                                <DisplayRemainingCharacters
                                    characterLimit={inputLimit.dps_articles.hubspot_form_id}
                                    current={hubspot_form_id}
                                />
                            </div>
                            <div className={`input_container`}>
                                {call_to_action ?
                                    <label>{`eBook Call To Action (i.e. Download Now!)`}</label>
                                : null}
                                <input
                                    className={`input_basic`}
                                    type='text'
                                    name={`call_to_action`}
                                    placeholder={`eBook Call To Action (i.e. Download Now!)`}
                                    value={call_to_action ? call_to_action : ''}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={inputLimit.dps_articles.call_to_action}
                                />
                                <DisplayRemainingCharacters
                                    characterLimit={inputLimit.dps_articles.call_to_action}
                                    current={call_to_action}
                                />
                            </div>
                        </div>

                    </div>
                    <div className={styles.article_upload_form_wrapper}>
                        <p className={styles.article_upload_header}>{`PDF Upload (if relevant)`}</p>
                       <div className={styles.article_upload_container}>
                            <DropzoneArea
                                acceptedFiles={['application/pdf']}
                                dropzoneClass={classes.dropZone}
                                showPreviewsInDropzone={false}
                                showFileNameOutsideBox={true}
                                filesLimit={1}
                                onChange={(e) => handleDrop(e, 'pdf_link')}
                                onDelete={() => handleDelete('pdf_link')}
                                refresh={clearPDF}
                                // dropzoneText="Add PDF"
                            />
                        </div>
                        <div className={`input_container`}>
                            {pdf_link ?
                                <label>PDF Link</label>
                            : null}
                            <input
                                className={`input_basic`}
                                type='text'
                                name={`pdf_link`}
                                placeholder="PDF Link"
                                value={pdf_link ? pdf_link : ''}
                                onChange={(e) => handleChange(e)}
                                maxLength={inputLimit.dps_articles.pdf_link}
                            />
                            <DisplayRemainingCharacters
                                characterLimit={inputLimit.dps_articles.pdf_link}
                                current={pdf_link}
                            />
                        </div>

                    </div>
                </div>
            : null}

       
     
            
            </div>
            <div className={styles.article_form_button_container}>
                <button className={`button_text button_text_black`} onClick={handleClose}>Cancel</button>
                {formPage > 0 ? 
                    <button className={`button_text`} onClick={() => changeFormPage('back')}>Back</button>
                : null}
                {formPage < 2? 
                    <button className={`button_text`} onClick={() => changeFormPage('next')}>Next</button>
                : null}
                {formPage === 2 ? 
                    <>
                        {selectedArticle && is_templated ?
                            <button className={'button_text'} onClick={viewTemplate}>
                                Review Template
                            </button>
                        : null}
                        <button className={`button_text`} onClick={(e) => handleSubmit(e)}>Submit</button>
                    </>
                : null}
            </div>
        </div>
    );
};

ArticleForm.propTypes = {
    updateArticle: PropTypes.func.isRequired,
    article: PropTypes.object.isRequired,
    articleType: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    article: state.article,
    articleType: state.articleType,
    product: state.product,
    auth: state.auth
});

export default connect(mapStateToProps, {
    addArticle,
    updateArticle, 
    getArticleProducts, 
    searchProducts, 
    addArticleProductAssociation, 
    deleteArticleProductAssociation, 
    getAllUsers, 
    setAlert, 
    selectArticleForTemplate, 
    setReturnUrl, 
    getArticleTypes,
    getAllUrlTitles
})(
    ArticleForm
);
